var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"navigation-header text-truncate text-primary"},[_c('span',[_vm._v(" "+_vm._s(this.item.header)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }